import { createApi } from '@reduxjs/toolkit/query/react';

import { apiInvoiceStatuses, apiInvoiceStatusTransitions } from '~constants/api';

import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';
import { get } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

import { InvoiceStatusTransitions } from '~lookups/models';

export const typePrefix = 'invoice-statuses';

const config = [
  { actionType: 'getAll', apiPath: apiInvoiceStatuses, method: get },
  { actionType: 'getOne', apiPath: (params: Params) => `${apiInvoiceStatuses}/${params.id}`, method: get },
];

export const invoiceStatusesApi = createApi({
  reducerPath: 'invoiceStatusesApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiInvoiceStatusTransitions }),
  tagTypes: ['invoice-statuses/transitions'],
  endpoints: (builder) => ({
    getInvoiceStatusTransitions: builder.query<InvoiceStatusTransitions[], Request | void>({
      query: () => ({ url: '', method: 'GET' }),
      providesTags: [{ type: 'invoice-statuses/transitions', id: 'LIST' }],
      transformResponse: (payload) => unwrap<InvoiceStatusTransitions[]>(payload),
    }),
  }),
});

export const { useGetInvoiceStatusTransitionsQuery } = invoiceStatusesApi;

export const { getAll, getOne } = createThunks(typePrefix, config);
